import {
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconComponent } from '../../atoms/icon/icon.component';
import { Colors, Sizes } from '../../../shared/enums/shared.enums';
import { CaasComponent } from '../../../shared/interfaces/caas/caas.interface';

@Component({
  selector: 'hdi-quote',
  standalone: true,
  imports: [CommonModule, IconComponent],
  templateUrl: './quote.component.html',
  styleUrl: './quote.component.scss',
  host: {
    id: crypto.randomUUID().toString(),
  },
})
export class QuoteComponent implements OnChanges {
  @Input() quote: string = '';
  @Input() quote_headline: string = '';
  @Input() quote_name: string = '';
  @Input() quote_subline: string = '';
  @Input() caasData?: CaasComponent;
  color = Colors;
  size = Sizes;

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['caasData'] && this.caasData) {
      this.setCaasContent(this.caasData);
      this.cdr.detectChanges();
    }
  }

  setCaasContent(caasData: CaasComponent): void {
    if (
      caasData?.formData?.st_items?.value &&
      Array.isArray(caasData.formData.st_items.value)
    ) {
      const firstQuote = caasData.formData.st_items.value[0];

      if (firstQuote?.formData) {
        this.quote = firstQuote.formData.st_text?.value || '';
        this.quote_name = firstQuote.formData.st_person?.value || '';
        this.quote_subline = firstQuote.formData.st_subline?.value || '';
      }
    }
  }
}
